import gsap from "gsap/all";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

export default () => {
  return {
    items: [],
    itemsFiltered: [],
    itemsFilteredAndPaginated: [],
    pagination: {
      page: 1,
      perPage: 10,
      listWindow: 5,
      list: [],
      maxPage: 1,
      // mode: 'pagination'
      mode: "infinite-scroll",
      // modeThreshold: 1024
      modeThreshold: 768,
    },

    paginationInit(items) {
      this.items = items;

      this.paginationDetectMode();

      this.filterItems();
      this.setPage(this.pagination.page);

      window.addEventListener("resize", () => this.paginationDetectMode());

      this.watchPageChange();
    },

    watchPageChange() {
      // scroll up on page change
      this.$watch("pagination.page", () => {
        // only scroll on desktop sizes
        if (window.innerWidth < 768) return;

        gsap.to(window, {
          delay: 0.1,
          duration: 1,
          scrollTo: { y: ".filters", offsetY: 120 },
        });
      });
    },

    // should be overridden if actual component implements filtering
    filterItems() {
      this.itemsFiltered = this.items;
    },

    paginateItems() {
      if (this.pagination.mode === "pagination") {
        this.itemsFilteredAndPaginated = this.itemsFiltered.slice(
          (this.pagination.page - 1) * this.pagination.perPage,
          this.pagination.page * this.pagination.perPage
        );
      } else if (this.pagination.mode == "infinite-scroll") {
        this.itemsFilteredAndPaginated = this.itemsFiltered.slice(
          0,
          this.pagination.page * this.pagination.perPage
        );
      }
      this.generatePaginationList();
    },

    setPage(page) {
      this.pagination.maxPage = Math.ceil(
        this.itemsFiltered.length / this.pagination.perPage
      );
      this.pagination.page = Math.min(
        Math.max(page, 1),
        this.pagination.maxPage
      );
      this.paginateItems();
    },

    generatePaginationList() {
      const fullList = Array.from(Array(this.pagination.maxPage).keys()).map(
        (x) => ++x
      );
      const windowIndex = Math.ceil(
        this.pagination.page / this.pagination.listWindow
      );
      this.pagination.list = fullList.slice(
        (windowIndex - 1) * this.pagination.listWindow,
        windowIndex * this.pagination.listWindow
      );
    },

    paginationGoToPage(page) {
      return {
        ["@click"]() {
          this.setPage(page);
        },
        [":class"]() {
          return parseInt(page) === this.pagination.page
            ? "active"
            : "cursor-pointer";
        },
      };
    },

    paginationGoToPageHover(page) {
      return {
        [":class"]() {
          return parseInt(page) === this.pagination.page
            ? "bg-btn-hover text-white"
            : "text-btn-hover group-hover:bg-orange-900 group-hover:text-white";
        },
      };
    },

    paginationGoToPreviousPage() {
      return {
        ["@click"]() {
          this.setPage(this.pagination.page - 1);
        },
        [":class"]() {
          return this.pagination.page === 1 ? "" : "cursor-pointer";
        },
      };
    },

    paginationGoToPreviousPageHover() {
      return {
        [":class"]() {
          return this.pagination.page === 1
            ? "text-gray-500"
            : "text-btn-hover group-hover:bg-orange-900 group-hover:text-white";
        },
      };
    },

    paginationGoToNextPage() {
      return {
        ["@click"]() {
          this.setPage(this.pagination.page + 1);
        },
        [":class"]() {
          return this.pagination.page === this.pagination.maxPage
            ? ""
            : "cursor-pointer";
        },
      };
    },

    paginationGoToNextPageHover() {
      return {
        [":class"]() {
          return this.pagination.page === this.pagination.maxPage
            ? "text-gray-500"
            : "text-btn-hover group-hover:bg-orange-900 group-hover:text-white";
        },
      };
    },

    paginationHasPreviousListWindow() {
      return this.pagination.page > this.pagination.listWindow;
    },

    paginationHasNextListWindow() {
      return (
        Math.ceil(this.pagination.page / this.pagination.listWindow) <
        Math.ceil(this.pagination.maxPage / this.pagination.listWindow)
      );
    },

    paginationSetMode(mode) {
      if (mode !== "pagination" && mode !== "infinite-scroll") {
        return;
      }
      this.pagination.mode = mode;
    },

    paginationDetectMode() {
      this.paginationSetMode(
        window.innerWidth >= this.pagination.modeThreshold
          ? "pagination"
          : "infinite-scroll"
      );
    },

    paginationShowMore() {
      return {
        ["x-show"]() {
          return (
            this.pagination.mode === "infinite-scroll" &&
            this.pagination.page < this.pagination.maxPage
          );
        },
      };
    },

    paginationShowMoreButton() {
      return {
        ["@click"]() {
          this.setPage(this.pagination.page + 1);
        },
      };
    },
  };
};
